var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grafico-linha",staticStyle:{"margin-top":"50px"}},[_c('ApexCharts',{staticClass:"component apexcharts-canvas",attrs:{"type":"line","height":"450","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }